import styled from 'styled-components';

export const Container = styled.div`
  .cke_button_label {
    display: none !important;
  }

  .cke_toolbar {
    display: flex !important;
    justify-content: space-around !important;
  }

  [class$="_label"] {
    display: none !important;
  }

  #cke_1_toolbox { 
    display: flex !important;
  }
`;
